var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalmart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1233 38.4805C24.7598 38.4805 23.6117 39.1739 23.4622 40.0655L22.1106 54.9831C22.1106 56.4603 23.8956 57.6694 26.1233 57.6694C28.3629 57.6694 30.1361 56.4603 30.1361 54.9831L28.7727 40.0655C28.629 39.1739 27.4869 38.4805 26.1233 38.4805Z",
    fill: "#FDE2CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4159 33.8125C33.7402 34.978 33.7791 36.2716 34.5086 36.8485L47.1269 45.4465C48.4395 46.1924 50.4041 45.3037 51.5283 43.4216C52.6496 41.5423 52.4224 39.4328 51.1367 38.7015L37.1669 32.3907C36.2728 32.0644 35.1037 32.6704 34.4159 33.8242",
    fill: "#FDE2CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8326 33.8245C17.1181 32.6707 15.949 32.0647 15.0788 32.3735L1.10904 38.7019C-0.188722 39.4478 -0.383096 41.5368 0.714285 43.4161C1.83559 45.2983 3.81209 46.1811 5.12171 45.4498L17.743 36.8605C18.4427 36.2749 18.4935 34.9754 17.8178 33.8129",
    fill: "#FDE2CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1233 19.8468C24.7598 19.8468 23.6117 19.1534 23.4622 18.2618L22.1106 3.34416C22.1106 1.86696 23.8956 0.669475 26.1233 0.669475C28.3629 0.669475 30.1361 1.86696 30.1361 3.34416L28.7727 18.2618C28.629 19.1534 27.4869 19.8468 26.1233 19.8468Z",
    fill: "#FDE2CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8326 24.501C17.1181 25.6577 15.949 26.2754 15.0788 25.9404L1.10904 19.6237C-0.188722 18.8924 -0.383096 16.7858 0.714286 14.9036C1.83559 13.036 3.81209 12.1474 5.12171 12.8787L17.743 21.4796C18.4427 22.0594 18.4935 23.3531 17.8178 24.501",
    fill: "#FDE2CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4159 24.5138C33.7402 23.3513 33.7791 22.0606 34.5086 21.4778L47.1269 12.8915C48.4395 12.1456 50.4041 13.0371 51.5283 14.9048C52.6497 16.784 52.4224 18.8935 51.1367 19.6248L37.1669 25.9415C36.2728 26.2736 35.1037 25.6618 34.4159 24.5138Z",
    fill: "#FDE2CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmart);
export default __webpack_public_path__ + "static/media/walmart.a59c27c2f6d21d8cbba214016fb80668.svg";
export { ForwardRef as ReactComponent };